class ShopifyCart {
  constructor() {
    this.isCartOpen = false
    this.itemCount = 0
    this.totalPrice = 0
    this.items = []
  }

  setupGiftWrap() {
    const giftWrapButton = document.querySelector('[data-gift-wrap]');
    if (giftWrapButton) {
      const checkbox = giftWrapButton.querySelector('input[type="checkbox"]');
      if (checkbox) {
        console.log(checkbox.checked)
        if (checkbox.checked) {
          this.addGiftWrap();
        } else {
          this.removeGiftWrap();
        }
      }
    }
  }

  /**
   * Events
   */
  onClickAddProduct(quantity, variantId) {
    const data = new FormData()
    data.append('id', variantId)
    data.append('quantity', quantity)

    fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: data,
      })
        .then(response => response.json())
        .then((response) => {
          let productAlreadyInCart = false

          this.items.forEach(item => {
            if (item.variant_id === variantId) {
              productAlreadyInCart = true
            }
          })

          if (productAlreadyInCart) {
            this.renderLineItemUpdate(response, false)
          } else {
            this.renderAddProduct(response)
          }

        
          this.update()
          this.show()
        })
        .catch((err) => {
          console.log(err)
        })
  }

  verifyGiftWrap() {
    const giftWrapButton = document.querySelector('[data-gift-wrap]');
    console.log(giftWrapButton)
    if (giftWrapButton) {
      const checkbox = giftWrapButton.querySelector('input[type="checkbox"]');
      if (checkbox) {
        const hasGiftWrap = this.items.some(item => item.variant_id == "44549964988572");
        checkbox.checked = hasGiftWrap;
      }
    }
  }

  onClickUpdateProductQtd(quantity, id) {
    const item = this.items.find(item => item.id === id)    

    item.quantity = item.quantity + quantity
    
    if (item.quantity >= 0) {
      const data = {updates: {}}

      data.updates[id] = item.quantity

      this.renderLineItemUpdate(item, quantity === -1)

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((_) => {          
          this.update()
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  /**
   * Listeners
   */
  addListenersToCart() {

  }

  /**
   * Show
   */
  show() {
    $("html").addClass("modal-open");
		$(".side-cart").removeClass("side-cart--hidden");
  }

  /**
   * Hide
   */
  hide() {
    $("html").removeClass("modal-open");
    $(".side-cart").addClass("side-cart--hidden");
  }

  /**
   * Render
   */
  renderAddProduct(item) {
    $('.side-cart__content__items__empty').remove()
    
    const newLineItem = `
      <li>
        <div id="${item.id}" class="side-cart__content__items__item">
          <a href="${item.url}">
            ${item.title.split(' - ')[0]}
          </a>

          <div>
            <span>${item.title.split(' - ')[1] ?? ''}</span>

            <img src=${item.featured_image.url}  alt=${item.title} class="cartimg">

            <div class="side-cart__content__items__item__update-buttons">
              <button type="button" onclick="window.cart.onClickUpdateProductQtd(-1, ${item.id})">-</button>
              <span
                id="${item.id}-quantity"
                class="side-cart__content__items__item__update-buttons__quantity"
              >
                ${item.quantity }
              </span>
              <button type="button" onclick="window.cart.onClickUpdateProductQtd(1, ${item.id})">+</button>
            </div>

            <span id="${item.id}-sub-total" class="side-cart__content__items__item__price">
              ${this.formatPrice(item.quantity * item.price)}
            </span>
          </div>
        </div>
      </li>
    `

    $('.side-cart__content__items').append(newLineItem)
  }

  renderLineItemUpdate(item, isRemoving) {
    $(`#${item.id}-quantity`)
        .html(String(item.quantity))

    $(`#${item.id}-sub-total`)
      .html(String(this.formatPrice(item.price * item.quantity)))


    if (isRemoving) {
      if (item.quantity === 0) {
        $(`#${item.id}`)[0].parentElement.remove()
      }
      if (this.itemCount - 1 === 0) {
        $('.side-cart__content__items').html('<p class="side-cart__content__items__empty">O seu carrinho está vazio.</p>')      
      }
    }
  }

  renderLineItemsResume() {
    $('.side-cart__header__quantity').html(`${this.itemCount} itens`)
    $('.side-cart__content__resume__total').html(this.totalPrice)
  
    // header
    $('.header__line-items-count').html(this.itemCount)

    if (this.itemCount > 0) {
      $('button[name=checkout]').attr('data-hidden', false)
    } else {
      $('button[name=checkout]').attr('data-hidden', true)
    }
  }

  /**
   * Update
   */
  update() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(({ item_count, items, total_price }) => {
        this.itemCount = item_count
        this.items = items
        console.log(this.items)
        this.totalPrice = this.formatPrice(total_price)
        
        this.renderLineItemsResume()
        this.verifyGiftWrap();
      });
  }

  addGiftWrap() {
    const giftWrapVariantId = "44549964988572";
    const formData = new FormData();
    formData.append('id', giftWrapVariantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    })
      .then(response => response.json())
      .then((response) => {
        this.renderAddProduct(response)
        this.update()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  removeGiftWrap() {
    const formData = {
      updates: {
        "44549964988572": 0
      }
    };

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((_) => {
        this.items = this.items.filter(item => item.variant_id !== "44549964988572");
        this.renderLineItemUpdate({ id: "44549964988572", quantity: 0 }, true);
        this.update()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  /**
   * Utils
   */
  formatPrice(value)
  {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value/100).replace(/\D00$/, '');
  }
}

window.cart = new ShopifyCart()
window.cart.update()
